/**
 * Handles processing of URLs by replacing variables with values.
 * 
 * NB: This class uses `module.export` instead of ES6 `export default`, so it is supported 
 * by the WebPack Plugins and can be shared between game and build code.
 */
class AssetUrlHelper {
    /**
     * Processes URL by replacing interpolating variables with the given values
     * @param {string} path 
     * @param {string} languageCode 
     * @returns {string}
     */
    static resolvePath(path, languageCode) {
        return path.replace(this.LanguageCodeVariable, `assets.localized/${languageCode?.toLowerCase()}`);
    }

    /**
     * 
     * @param {string} path 
     * @returns boolean
     */
    static hasLanguageCode(path) {
        return path.includes(this.LanguageCodeVariable);
    }
}

AssetUrlHelper.LanguageCodeVariable = "%LOCALIZED_ASSETS%";

module.exports = AssetUrlHelper;